export class DashboardCharts {
    public issuesReturnsChartLabels:string[] = ['Returns', 'Renews', 'Issues'];
    public issuesReturnsChartData: number[] = [ 0,0,0 ];
    public issuesReturnsChartType: string = 'doughnut';
    public issuesReturnsChartLegend: boolean = false;
    public issuesReturnsChartColors: any[] = [
        {
            backgroundColor: [ "#ddb4e4", "#b31dcc", "#cc8fd6" ],
            borderColor: [ "rgba(255,255,255, 0)", "rgba(255,255,255, 0)", "rgba(255,255,255, 0)" ]
        }
    ];

    public issuesReturnsChartOptions: any = {
    };

    public gateCountsChartOptions: any = {
        responsive: true,
        scales: {
            xAxes: [{
                gridLines: {
                    display: false,
                }
            }],
            yAxes: [{
                gridLines: {
                    display: false
                },
                ticks: {
                    beginAtZero: true
                }
            }]
        }
    };

    public gateCountsChartLabels: string[] = [];
    public gateCountsChartType: string = 'bar';
    public gateCountsChartLegend: boolean = false;

    public gateCountsChartData: any[] = [];

    public gateCountsChartColors: any[] = [
        { backgroundColor: [] },
        { backgroundColor: [] }
    ];
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/components/dashboard/dashboard-charts.ts